import React, { useEffect, useRef, useState } from "react";
import Joinus from "../../common/Joinus";
import { gridbulk, initialStates, servicessender, smsServiceDetails } from "../home/Constant";
import ServiceSenderAni from "./ServiceSenderAni";
import WhatWeDo from "./WhatWeDo";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel3";

const ServiceSender = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="margin-topall">
      <section className="py-5 service-position">
        <div className="container">
          <div className="metabulk-bg-round">
            {colors.map((color, i) => (
              <div
                key={i}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  top: `${initialStates[i].top}px`,
                  left: `${initialStates[i].left}px`,
                  width: `${initialStates[i].width}px`,
                  height: `${initialStates[i].height}px`,
                  marginLeft: `${initialStates[i].marginLeft}px`,
                  opacity: initialStates[i].opacity,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                  willChange: "top, left, width, height, opacity, margin-left",
                }}
              />
            ))}
          </div>
          <div className="pos-z-index">
            <div className="row justify-content-center">
              <div className="col-lg-8"
                data-aos="fade-up" data-aos-delay="300"
              >
                <div className="">
                  <h5 className="yellow-sub-heading text-center py-2 ">
                    SMS Marketing Services
                  </h5>
                  {/* <h4 className="black-service-heading text-center font-align mt-3">
                                    Unlock 5x Revenue Growth
                                </h4> */}
                  <div className="smsbulk-sub-heading">
                    <div>
                      SMS marketing is a powerful and direct communication channel that allows businesses to send branded messages
                      using a custom sender name instead of a random mobile number. With our reliable SMS service,
                      recipients instantly recognize your brand when messages appear as “Your Brand”, helping build trust and credibility.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhatWeDo data={smsServiceDetails} />
      <ServiceSenderAni />
      <section className="overflow-hidden">
        <div className="container">

          {gridbulk.map((item, index) => (
            <div className="row gridflex">
              <div className={`col-lg-6  ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-2'}`}
                data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`} data-aos-delay="300"
              >
                <div className="d-flex gap-2">
                  <div className="circleservice">{index + 1}</div>
                  <h1 className="servicebenefit">{item.heading}</h1>
                </div>
                <div className="servicefontb ">
                  <p className="py-2">{item.para1}</p>
                </div>
              </div>
              <div className={`col-lg-6 gridimage ${index % 2 === 0 ? 'order-lg-2' : 'order-lg-1'}`}
                data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`} data-aos-delay="300"
              >
                <img className="bulkwidth" src={item.img} alt={`Visual for ${item.heading}`} />
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* <WhatDo/> */}
      <section className="py-5">
        <div className="container">
          <div>
            <h1 className="faqfont">FAQs - (Bulk SMS)</h1>
          </div>
          <div className="py-5">
            <div class="accordion" id="accordionExample"
              data-aos="fade-right" data-aos-delay="300"
            >
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What is DLT?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body sms-span">
                    DLT (Distributed Ledger Technology) is a blockchain-based SMS registration system
                    introduced by TRAI to regulate and secure SMS marketing in India.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How does Bulk SMS work?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse "
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>
                        Businesses register a unique sender name (e.g.,{" "}
                        <span className="boldspan">"ABCStore" </span>).
                      </li>
                      <li>
                        SMS messages are sent to customers from this sender name
                        instead of a random number.
                      </li>
                      <li>
                        Customers receive the SMS with the sender's brand name,
                        improving trust and engagement
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What are the types of Bulk SMS?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>
                        <span className="boldspan">Transactional SMS </span>–
                        Used for OTPs, order updates, account alerts, and
                        confirmations.
                      </li>
                      <li>
                        <span className="boldspan">Promotional SMS </span>– Used
                        for marketing, offers, discounts, and announcements.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Is Bulk SMS available worldwide?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Yes. However, Sender ID rules vary by country, and some regions
                    require pre-registration for SMS marketing services.
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFive">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Can customers reply to a Bulk SMS?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Bulk SMS is typically one-way. For two-way communication, a virtual number or short code-based SMS service is required.
                  </div>
                </div>
              </div>
              {showAll && (
                <>
                  <div class="accordion-item border-top ">
                    <h2 class="accordion-header" id="headingSix">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        <span class="me-3 toggle-icon"></span>
                        How can I register my Bulk SMS?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>
                            Choose a{" "}
                            <span className="boldspan">
                              unique sender name{" "}
                            </span>{" "}
                            (usually{" "}
                            <span className="boldspan">
                              6-11 characters, no spaces).
                            </span>
                          </li>
                          <li>
                            Provide
                            <span className="boldspan">
                              business verification
                            </span>
                            (some regions require approval).
                          </li>
                          <li>
                            Once approved, send SMS using your custom{" "}
                            <span className="boldspan">sender name.</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingSeven">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        <span class="me-3 toggle-icon"></span>
                        What industries benefit from Bulk SMS?
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>
                            <span className="boldspan">E-commerce </span>– Order
                            updates, delivery notifications.
                          </li>
                          <li>
                            <span className="boldspan">Banks & Finance </span>–
                            OTPs, transaction alerts.
                          </li>
                          <li>
                            {" "}
                            <span className="boldspan">Healthcare </span>–
                            Appointment reminders, lab reports.
                          </li>
                          <li>
                            {" "}
                            <span className="boldspan">
                              Travel & Hospitality
                            </span>
                            – Booking confirmations, flight alerts.
                          </li>
                          <li>
                            {" "}
                            <span className="boldspan">
                              Marketing & Retail{" "}
                            </span>
                            – Promotions, discounts, loyalty programs.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingEight">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight"
                        aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Why is DLT Mandatory?
                      </button>
                    </h2>
                    <div
                      id="collapseEight"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingEight"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>Prevent SMS fraud and spam</li>
                          <li>
                            Ensure only registered businesses can send SMS
                          </li>
                          <li>Increase transparency and security</li>
                          <li>Protect customers from unsolicited messages</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingNine">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseNine"
                        aria-expanded="false"
                        aria-controls="collapseNine"
                      >
                        <span class="me-3 toggle-icon"></span>
                        How DLT Works?
                      </button>
                    </h2>
                    <div
                      id="collapseNine"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingNine"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Businesses register on a DLT platform{" "}
                        <span className="boldspan">
                          (e.g., Airtel, Jio, Vodafone).
                        </span>
                        They submit their Sender ID, message templates, and
                        consent proofs. Once approved, they can send SMS using
                        their Sender ID.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingTen">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTen"
                        aria-expanded="false"
                        aria-controls="collapseTen"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Who Needs to Register for DLT?
                      </button>
                    </h2>
                    <div
                      id="collapseTen"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingTen"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>
                            <span className="boldspan">
                              {" "}
                              Any business or individual sending bulk SMS in
                              India
                            </span>{" "}
                            for promotions, alerts, OTPs, etc.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingEleven">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEleven"
                        aria-expanded="false"
                        aria-controls="collapseEleven"
                      >
                        <span class="me-3 toggle-icon"></span>
                        What Happens If You Don’t Register?
                      </button>
                    </h2>
                    <div
                      id="collapseEleven"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingEleven"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>
                            <span className="boldspan">
                              Your SMS will be blocked
                            </span>{" "}
                            by telecom operators.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="text-center py-3 ">
                <button
                  className="btn-sm viewbtn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Joinus />
    </div>
  );
};

export default ServiceSender;
